import {
    MAINTENANCE_PACKAGE_AUTH,
    UPDATE_PERMISSION,
    DELETE_PERMISSION,
    CREATE_PERMISSION,
} from 'src/constants/permissions';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';
import { IUser } from 'src/interfaces/user';
import { DEVELOPER_LEVEL_ACCESS } from 'src/components/access';

export const canUpdateMaintenancePackage = (user: IUser) => {
    return isPermissionGranted({
        permissions: user?.permissions || {},
        permission: MAINTENANCE_PACKAGE_AUTH,
        crud: UPDATE_PERMISSION,
    });
};
export const canDeleteMaintenancePackage = (user: IUser) => {
    const isDeveloper = user?.accessLevel === DEVELOPER_LEVEL_ACCESS;

    return (
        isDeveloper &&
        isPermissionGranted({
            permissions: user?.permissions || {},
            permission: MAINTENANCE_PACKAGE_AUTH,
            crud: DELETE_PERMISSION,
        })
    );
};
export const canCreateMaintenancePackage = (user: IUser) => {
    return isPermissionGranted({
        permissions: user?.permissions || {},
        permission: MAINTENANCE_PACKAGE_AUTH,
        crud: CREATE_PERMISSION,
    });
};
